/* KinderSpeech 2.0 - Angle 1 listicle
   Progressive enhancement: scroll-reveal animation.
   Nem kritikus: ha nem tolt be, a tartalom akkor is latszik (a --js
   osztaly nelkul a CSS nem rejt el semmit). */
(function () {
  function init() {
    var root = document.querySelector('.kslist');
    if (!root) return;

    // Csak ha van JS: bekapcsoljuk a rejtett kezdoallapotot.
    root.classList.add('kslist--js');

    var items = root.querySelectorAll('[data-reveal]');

    // Ha nincs IntersectionObserver, azonnal mindent megmutatunk.
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

    items.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();